import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Common
import ScrollToTop from './components/common/ScrollToTop';
import FluoRibbonIntro from './components/common/FluoRibbonIntro';

// Layout
import MainLayout from './layout/MainLayout';

// Pages - Lazy loaded
const HomePage = lazy(() => import('./pages/home/HomePage'));
const AboutPage = lazy(() => import('./pages/about/AboutPage'));
const MethodPage = lazy(() => import('./pages/method/MethodPage'));
const ServicesPage = lazy(() => import('./pages/services/ServicesPage'));
const ContactPage = lazy(() => import('./pages/contact/ContactPage'));
const PortfolioPage = lazy(() => import('./pages/portfolio/PortfolioPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/privacy/PrivacyPolicyPage'));
const NotFoundPage = lazy(() => import('./pages/not-found/NotFoundPage'));

// A simple loading fallback that maintains the layout background color
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50">
    <div className="w-8 h-8 rounded-full border-2 border-[#4601FA] border-t-transparent animate-spin"></div>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <FluoRibbonIntro />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/method" element={<MethodPage />} />
            <Route path="/metodo" element={<MethodPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/servizi" element={<ServicesPage />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
